module.exports = __webpack_public_path__ + "img/logo.7410d8d2.png";